
import useVuelidate from '@vuelidate/core'
import { required, minLength, email } from '@vuelidate/validators'

const mustBePhoneNumber = (value) => {
    const val = value.replaceAll(' ', '');
    return /^([0-9]{10,})$/.test(val);
}
const mustBeBirthday = (value) => {
    let val = value.replaceAll(' ', '');
    val = val.replaceAll('-', '');
    val = val.replaceAll('/', '');
    return /^([0-9]{8,})$/.test(val);
}
export default {
    head() {
        return {
            title: `Votre admission`,
            meta: null
        };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri

        const isOpen = false

        let loginForm = {
            telephone: '',
            dateNaissance: '',
            // telephone: '0611397180',
            // dateNaissance: '01/12/2009',
        };

        let formSent = false;
        let sending = false;
        let sendingForm = false;
        let badLogin = false;
        let isLogged = false;
        let saved = false;

        let yearBAC = [];
        let filteredVillesLycee = []
        let filteredLycees = []

        const currentYear = new Date().getFullYear();

        for (let i = 1; i < 10; i++) {
            yearBAC.push(currentYear - i);
        }
        // yearBAC[0] = 'En cours d\'obtention en ' + currentYear;

        return {
            strapiBaseUri,
            loginForm,
            formSent,
            sending,
            sendingForm,
            isLogged,
            isMounted: false,
            isOpen,
            yearBAC,
            currentYear,
            badLogin,
            saved,
            filteredVillesLycee,
            filteredLycees,
            student: {},
        }
    },

    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            loginForm: {
                dateNaissance: { required, mustBeBirthday },
                telephone: { required, mustBePhoneNumber, minLength: minLength(10) },
            },
        }
    },
    mounted() {
        // this.logIn();
        this.isMounted = true;

    },
    methods: {
        preventSending() {
        },


        formateDateNaissance(date) {
            let val = date.replaceAll(' ', '');
            val = val.replaceAll('-', '');
            val = val.replaceAll('/', '');
            val = val.substring(4, 8) + '-' + val.substring(2, 4) + '-' + val.substring(0, 2);
            return val
        },

        async logIn() {
            try {
                if (await this.v$.loginForm.$validate()) {
                    this.badLogin = false;
                    this.saved = false;
                    this.sending = true;
                    this.loginForm.dn = this.formateDateNaissance(this.loginForm.dateNaissance)
                    let formData = new FormData();
                    formData.append('data', JSON.stringify(this.loginForm));

                    let result = await this.$http.$post(`${process.env.apiCrmServer}studentAdmisLogin.php?`, formData);
                    
                    if (result.id) {
                        this.isLogged = true;
                        this.student = result;
                        this.sending = false;
                        

                    }
                    else {
                        //TODO Display error message sayingf there is no student with such informations
                        this.sending = false;
                        this.badLogin = true;
                    }
                }
            } catch (error) {
                console.log(error)
                this.sending = false;
                this.isOpen = true
            }

        },        

        async saveStudent(admisForm) {
            try {
                this.sendingForm = true;
                admisForm.dn = admisForm.dateNaissance;
                let formData = new FormData();
                if (admisForm.cv?.name) {
                    formData.append('cv', admisForm.cv);
                    admisForm.cv = admisForm.cv?.name
                }
                formData.append('data', JSON.stringify(admisForm));


                let result = await this.$http.$post(`${process.env.apiCrmServer}studentAdmisSave.php?query=save&jwt=${admisForm.jwt}`, formData);
                if (result == "success") {
                    this.saved = true;
                    this.sendingForm = false;
                    this.isLogged = false;
                }
                else {
                    this.sendingForm = false;
                    this.isOpen = true
                }

            } catch (error) {
                this.sendingForm = false;
                this.isOpen = true
            }

        },
    },
    async asyncData({ params, store, $http }) {
        let instances = store.state.instances;
        let infoGenerales = JSON.parse(JSON.stringify(store.state.infoGenerales));

        let bacSeries = await $http.$get(`${process.env.apiCrmServer}bac.php?query=series`);
        bacSeries = bacSeries.filter(bacSerie => bacSerie.serie);
        let departemments = await $http.$get(`${process.env.apiCrmServer}departement.php?query=query`);
        let bacs = await $http.$get(`${process.env.apiCrmServer}bac.php?query=bacs`);
        let displayedBacs = bacs;

        return {
            params, instances, infoGenerales, bacSeries, bacs, displayedBacs, departemments
        }
    }

}



